export default function getStoriesBlockData(props) {
  const { storiesTitle, storiesDescription, storiesItems } = props;
  const data = {};

  data.title = storiesTitle || false;
  data.description = storiesDescription || false;
  data.list = storiesItems || false;

  const cardList = storiesItems ? [] : false;

  if (cardList) {
    storiesItems.map((entry, index) => {
      const item = {};
      item.id = index;

      item.title = entry?.fields?.title || false;
      item.description = entry?.fields?.subtitle || false;
      item.url = entry?.fields?.link || false;
      item.image = entry?.fields?.image?.fields?.file?.url ? {} : false;
      item.image.src = entry?.fields?.image?.fields?.file?.url || false;
      item.image.width = entry?.fields?.image?.fields?.file?.details?.image?.width || false;
      item.image.height = entry?.fields?.image?.fields?.file?.details?.image?.height || false;
      cardList.push(item);
      return true;
    });
  }

  data.list = cardList || false;

  return Object.keys(data).length ? data : false;
}
